import React from 'react';

import { HeaderWrapper, ResultsCount, ResultsSubtext } from '../styles';

export default function ResultsHeader({ query, totalCount }) {
  return (
    <HeaderWrapper>
      <ResultsCount>
        {query
          ? `Resultados para '${query}'`
          : `Mostrando ${totalCount} resultados`}
      </ResultsCount>
      {query && (
        <ResultsSubtext>
          {totalCount} {totalCount === 1 ? 'resultado encontrado' : 'resultados encontrados'}
        </ResultsSubtext>
      )}
    </HeaderWrapper>
  );
}
